<app-ui-document-panel-shell
  [breadcrumb]="breadcrumb"
  [title]="panelTitle"
  [documentId]="voucherNo || ''"
  (closed)="onClose()">

  <app-ui-form-section title="General Information" icon="info">
    <div class="ui-doc-panel-content__field-grid">
      <div class="ui-doc-panel-content__field">
        <mat-form-field appearance="outline">
          <mat-label>Invoice Type<span class="ui-doc-panel-content__required">*</span></mat-label>
          <mat-select [(ngModel)]="invoice_type" (selectionChange)="onInvoiceTypeChange($event.value)" [disabled]="isView">
            <mat-option value="sales" *ngIf="type === 'Sales Return'">Sales Voucher</mat-option>
            <mat-option value="debit note" *ngIf="type === 'Sales Return'">Debit Note Voucher</mat-option>
            <mat-option value="purchase" *ngIf="type === 'Purchase Return'">Purchase Voucher</mat-option>
            <mat-option value="credit note" *ngIf="type === 'Purchase Return'">Credit Note Voucher</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="ui-doc-panel-content__field">
        <mat-form-field appearance="outline">
          <mat-label>Branch<span class="ui-doc-panel-content__required">*</span></mat-label>
          <mat-select [(ngModel)]="branch" (selectionChange)="onBranchChange($event.value)" [disabled]="isView">
            <mat-option *ngFor="let item of branch_data" [value]="item.id">{{ item.name }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="ui-doc-panel-content__field" *ngIf="invoice_type === 'sales'">
        <mat-form-field appearance="outline">
          <mat-label>Sales Invoice<span class="ui-doc-panel-content__required">*</span></mat-label>
          <mat-select [(ngModel)]="salesInvoice" (selectionChange)="onInvoiceChange($event.value)" [disabled]="isView">
            <mat-option *ngFor="let inv of sales_invoice" [value]="inv.id">{{ inv.voucher_no }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="ui-doc-panel-content__field" *ngIf="invoice_type === 'debit note'">
        <mat-form-field appearance="outline">
          <mat-label>Debit Note<span class="ui-doc-panel-content__required">*</span></mat-label>
          <mat-select [(ngModel)]="debitNote" (selectionChange)="onInvoiceChange($event.value)" [disabled]="isView">
            <mat-option *ngFor="let inv of debit_note" [value]="inv.id">{{ inv.voucher_no }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="ui-doc-panel-content__field" *ngIf="invoice_type === 'purchase'">
        <mat-form-field appearance="outline">
          <mat-label>Purchase Invoice<span class="ui-doc-panel-content__required">*</span></mat-label>
          <mat-select [(ngModel)]="purchaseInvoice" (selectionChange)="onInvoiceChange($event.value)" [disabled]="isView">
            <mat-option *ngFor="let inv of purchase_invoice" [value]="inv.id">{{ inv.voucher_no }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="ui-doc-panel-content__field" *ngIf="invoice_type === 'credit note'">
        <mat-form-field appearance="outline">
          <mat-label>Credit Note<span class="ui-doc-panel-content__required">*</span></mat-label>
          <mat-select [(ngModel)]="creditNote" (selectionChange)="onInvoiceChange($event.value)" [disabled]="isView">
            <mat-option *ngFor="let inv of credit_note" [value]="inv.id">{{ inv.voucher_no }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="ui-doc-panel-content__field">
        <mat-form-field appearance="outline">
          <mat-label>Profit/Cost Center<span class="ui-doc-panel-content__required">*</span></mat-label>
          <mat-select [(ngModel)]="profit_cost_id" (selectionChange)="onProfitCostChange($event.value)" multiple [disabled]="isView">
            <mat-option *ngFor="let pc of profit_cost" [value]="pc.id">{{ pc.name }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="ui-doc-panel-content__field" *ngIf="isSalesParty">
        <mat-form-field appearance="outline">
          <mat-label>Customer Name</mat-label>
          <input matInput [value]="customers" disabled>
        </mat-form-field>
      </div>

      <div class="ui-doc-panel-content__field" *ngIf="isSalesParty">
        <mat-form-field appearance="outline">
          <mat-label>Customer Branch</mat-label>
          <input matInput [value]="cutomer_branchs" disabled>
        </mat-form-field>
      </div>

      <div class="ui-doc-panel-content__field" *ngIf="!isSalesParty && invoice_type">
        <mat-form-field appearance="outline">
          <mat-label>Vendor Name</mat-label>
          <input matInput [value]="vendors" disabled>
        </mat-form-field>
      </div>

      <div class="ui-doc-panel-content__field" *ngIf="!isSalesParty && invoice_type">
        <mat-form-field appearance="outline">
          <mat-label>Vendor Branch</mat-label>
          <input matInput [value]="vendor_branchs" disabled>
        </mat-form-field>
      </div>

      <div class="ui-doc-panel-content__field">
        <mat-form-field appearance="outline">
          <mat-label>Date<span class="ui-doc-panel-content__required">*</span></mat-label>
          <input type="date" matInput [(ngModel)]="date" [disabled]="isView">
        </mat-form-field>
      </div>
    </div>
  </app-ui-form-section>

  <app-ui-form-section title="Line Items" icon="list_alt" *ngIf="showLineItems">
    <p class="ui-doc-panel-table-hint">Scroll inside the table area to view all columns and rows.</p>
    <div class="ui-doc-panel-table-scroll">
      <table class="product-table ui-doc-line-table">
        <thead>
          <tr>
            <th>Profit/Cost</th>
            <th>Section</th>
            <th>Item/Service Name</th>
            <th>HSN/SAC No</th>
            <th>Description</th>
            <th>UOM</th>
            <th>Unit Price</th>
            <th>Quantity</th>
            <th>Value</th>
            <th>Discount</th>
            <th>Incentive</th>
            <th>GST %</th>
            <th>Pending Qty</th>
            <th>Return Qty</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of lineItems">
            <td>{{ item?.profit_cost_name }}</td>
            <td>{{ item?.section_name }}</td>
            <td class="ui-doc-line-table__wrap">{{ item?.name }}</td>
            <td>{{ item?.hsn_no }}</td>
            <td class="ui-doc-line-table__wrap">{{ item?.description }}</td>
            <td>{{ item?.unit_name }}</td>
            <td>{{ item?.unit_price | number:'1.2-2' }}</td>
            <td>{{ item?.qty | number:'1.3-3' }}</td>
            <td>{{ item.qty * item.unit_price | number:'1.2-2' }}</td>
            <td>{{ item?.discount_amount | number:'1.2-2' }}</td>
            <td>{{ item?.incentive_amount | number:'1.2-2' }}</td>
            <td>{{ item?.gst_percentage | number:'1.2-2' }}</td>
            <td>{{ item?.pending_qty | number:'1.3-3' }}</td>
            <td>
              <input
                type="text"
                [(ngModel)]="item.change_qty"
                (input)="limitDecimal($event, 3)"
                (ngModelChange)="ReturnQtyChange(item, $event)"
                [disabled]="isView"
                min="0.001"
                step="0.001">
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </app-ui-form-section>

  <app-ui-document-panel-footer
    [primaryActions]="footerPrimaryActions"
    [secondaryActions]="footerSecondaryActions"
    [destructiveAction]="footerDestructiveAction"
    [overflowActions]="footerOverflowActions"
    (actionClick)="onFooterAction($event)">
  </app-ui-document-panel-footer>
</app-ui-document-panel-shell>
